export function resolveConnectorRippleOffset(args) {
    const ripple = args.activation.ripple;
    if (!ripple || ripple.amplitude === 0 || args.length === 0)
        return 0;
    const progress = Math.max(0, Math.min(1, args.activation.progress01));
    if (progress === 0 || progress === 1 || args.fraction === 0 || args.fraction === 1)
        return 0;
    const travelFraction = args.activation.direction === 'to-from' ? 1 - args.fraction : args.fraction;
    const halfPulse = ripple.pulseLength / 2;
    const local = (travelFraction - progress) * args.length / halfPulse;
    if (Math.abs(local) >= 1)
        return 0;
    const envelope = Math.cos(local * Math.PI / 2) ** 2;
    const endpointFade = Math.min(1, travelFraction * args.length / halfPulse, (1 - travelFraction) * args.length / halfPulse);
    const arrivalFade = Math.min(1, progress * args.length / halfPulse, (1 - progress) * args.length / halfPulse);
    return ripple.amplitude * envelope * endpointFade * arrivalFade
        * Math.sin(local * Math.PI * ripple.oscillationCount);
}
